import { render, staticRenderFns } from "./fatFile-add.vue?vue&type=template&id=05a48812&scoped=true"
import script from "./fatFile-add.vue?vue&type=script&lang=js"
export * from "./fatFile-add.vue?vue&type=script&lang=js"
import style0 from "./fatFile-add.vue?vue&type=style&index=0&id=05a48812&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a48812",
  null
  
)

export default component.exports